import { IPortalPreferences } from "../@types/Preferences";
import { AUTH_PORTAL_PREFERENCES } from "../constants/localStorageKeys";
import { safeJsonParse, safeStorage } from "./storage";

/**
 * EN-5272: the display format of every single-date picker in the portal.
 *
 * The segmented DD / MM / YYYY fields these pickers replaced ordered their
 * segments by the portal country — month first for "US", day first everywhere
 * else — so that is what a clinician is used to typing. Keeping that order
 * matters most for dates of birth, where 03/05 typed the wrong way round is
 * still a valid date and nothing downstream would catch it.
 */
export const US_DATE_FORMAT = "MM/DD/YYYY";
export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";

/** What a picker's value is stored and sent as, independent of the display. */
export const DATE_VALUE_FORMAT = "YYYY-MM-DD";

export function getDateFormatForCountry(countryCode?: string): string {
  return countryCode === "US" ? US_DATE_FORMAT : DEFAULT_DATE_FORMAT;
}

export function getPortalCountryCode(): string | undefined {
  return safeJsonParse<IPortalPreferences | undefined>(
    safeStorage.getItem(AUTH_PORTAL_PREFERENCES),
    undefined
  )?.countryCode;
}

export function getPortalDateFormat(): string {
  return getDateFormatForCountry(getPortalCountryCode());
}
